import { yupResolver } from '@hookform/resolvers/yup';
import LoadingButton from '@mui/lab/LoadingButton';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Box,
  Divider,
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useEffect, useMemo } from 'react';
import { useForm } from 'react-hook-form';
import FormProvider, { RHFTextField } from 'src/components/hook-form';
import Iconify from 'src/components/iconify';
import * as Yup from 'yup';
import { postRequest } from 'src/services';
import { endpoints } from 'src/utils/axios';
import { enqueueSnackbar } from 'notistack';
import { handleErrorMessages } from 'src/components/risk-management/risk-register/feching';

const CreateCardDialog = ({ open, onClose, currentItem, reload, onAdd }) => {
  const theme = useTheme();
  const RoleSchema = Yup.object().shape({
    name: Yup.string().required('Name is required'),
  });
  const defaultValues = useMemo(
    () => ({
      name: currentItem?.name || '',
    }),
    [currentItem]
  );
  const methods = useForm({
    resolver: yupResolver(RoleSchema),
    defaultValues,
  });

  const {
    reset,
    handleSubmit,
    formState: { isSubmitting },
  } = methods;

  useEffect(() => {
    if (open) {
      reset(defaultValues);
    }
  }, [open, reset, defaultValues]);

  const onSubmit = handleSubmit(async (data) => {
    const formData = new FormData();
    formData.append('name', data?.name);
    try {
      const response = await postRequest(
        currentItem?.id
          ? `${endpoints.organizational_hierarchy.crud_heirarchy}/${currentItem?.id}?_method=PUT`
          : endpoints.organizational_hierarchy.crud_heirarchy,
        formData,
        true
      );
      if (response?.metadata) {
        reset();
        onClose();
        reload();
        enqueueSnackbar({
          variant: 'success',
          message: response?.metadata?.message || 'Added successfully!',
        });
      } else {
        handleErrorMessages(response?.message);
      }
    } catch (err) {
      handleErrorMessages(err?.response?.data?.message || err?.message);
      console.log('Error in catch:', err);
    }
  });

  const handleClose = () => {
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={(event, reason) => {
        if (reason !== 'backdropClick') {
          onClose();
        }
      }}
      fullWidth
      maxWidth="sm"
      sx={{
        borderRadius: 'none',
        padding: '60px',
        fontSize: '13px',
        fontFamily: 'arial',
      }}
      transitionDuration={{
        enter: theme.transitions.duration.shortest,
        exit: theme.transitions.duration.shortest - 80,
      }}
    >
      <FormProvider methods={methods} onSubmit={onSubmit}>
        <DialogTitle
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            boxSizing: 'content-box',
          }}
        >
          <span
            className="cardColor"
            style={{
              padding: '7px',
              marginLeft: '-25px',
              color: 'white ',
              fontWeight: '700',
            }}
          >
            &nbsp;&nbsp; {currentItem ? 'Edit' : 'Add New'} &nbsp;&nbsp;&nbsp;&nbsp;
          </span>
          <br />
          <br />
          <IconButton onClick={handleClose}>
            <Iconify icon="mdi:close" />
          </IconButton>
        </DialogTitle>
        <Divider />
        <DialogContent sx={{ borderRadius: '1px' }}>
          <Box
            mt={2}
            rowGap={2}
            columnGap={2}
            display="grid"
            gridTemplateColumns={{
              xs: 'repeat(1, 1fr)',
              sm: 'repeat(1, 1fr)',
            }}
          >
            <RHFTextField name="name" label="Name *" />
          </Box>
        </DialogContent>
        <DialogActions>
          <Button variant="outlined" color="inherit" onClick={handleClose}>
            Close
          </Button>
          <LoadingButton
            type="submit"
            variant="contained"
            className="dark-button"
            loading={isSubmitting}
          >
            Submit
          </LoadingButton>
        </DialogActions>
      </FormProvider>
    </Dialog>
  );
};
export default CreateCardDialog;